<script setup>
import { useAppSettingsStore } from '@convatec/180medical-website/app/stores/app-settings'
import { computed, ref } from 'vue'

const props = defineProps(['model'])
const appSettingsStore = useAppSettingsStore()
const { showFooterForm } = useLayoutFlags()
showFooterForm.value = true

const relatedQuestions = ref([])

// Fetch related questions from API using the content link ID
const { data: relatedQuestionsData, error: fetchError } = useFetch('/api/questions/related', {
  query: {
    qId: props.model.contentLink.id,
  },
  method: 'GET',
})

// Create a deep copy to avoid modifying the original
const bodyBlocks = JSON.parse(JSON.stringify(props.model.bodyBlockArea?.expandedValue ?? []))

// Move this to a separate computed property
const filteredBodyBlockArea = computed(() => {
  if (!props.model.bodyBlockArea?.expandedValue)
    return null

  return bodyBlocks
})

// Transform breadcrumb data to match BreadCrumb component properties
const transformedBreadcrumbs = computed(() => {
  if (!props.model?.breadcrumbLinks?.value || props.model.breadcrumbLinks.value.length === 0) {
    return []
  }

  return props.model.breadcrumbLinks.value.map(item => ({
    label: item.text,
    to: item.href,
    id: item.contentLink?.id,
  }))
})

// Process related questions data when it becomes available
watchEffect(() => {
  if (fetchError.value) {
    console.error('Failed to fetch related questions:', fetchError.value)
    relatedQuestions.value = []
    return
  }

  if (relatedQuestionsData.value) {
    // Map the questions to the expected format
    if (relatedQuestionsData.value.questions && Array.isArray(relatedQuestionsData.value.questions)) {
      relatedQuestions.value = relatedQuestionsData.value.questions.map(question => ({
        url: question.url,
        text: question.questionTitle,
      }))
    }
    else {
      console.warn('Unexpected API response format', relatedQuestionsData.value)
      relatedQuestions.value = []
    }
  }
})
</script>

<template>
  <div class="general-page">
    <div class="container-fluid">
      <div class="general-page__wrap">
        <div class="main-body--wide">
          <BreadCrumb
            v-if="transformedBreadcrumbs.length > 0"
            :items="transformedBreadcrumbs"
          />
          <div class="general-page__title prose xl:!max-w-full !mb-7">
            <h1 v-if="model.pageTitle?.value">
              {{ model.pageTitle.value }}
            </h1>
          </div>
          <div class="general-page__body">
            <div class="body-block-area w-full">
              <GenericsContentArea
                v-if="filteredBodyBlockArea"
                :model="filteredBodyBlockArea"
              />
            </div>
            <aside class="sidebar">
              <SideRelatedList
                title="Related:"
                :links="relatedQuestions"
              />
              <ScrollToFormBlock
                :title="appSettingsStore?.contactSettings?.scrollToTitle"
                :body="appSettingsStore?.contactSettings?.scrollToBody"
                :text="appSettingsStore?.contactSettings?.scrollToText"
              />
            </aside>
          </div>
        </div>
      </div>

      <div class="page-block-area eight-col-max mx-auto">
        <GenericsContentArea :model="model.pageBlockArea.expandedValue" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/general-page.scss';
</style>
